<template>
  <div>
    <CCard v-show="empresas.length <= 0" accent-color="secondary">
      <CCardHeader class="text-center">
        <CRow>
          <CCol>Seleccione un periodo para mostrar información</CCol>
        </CRow>
      </CCardHeader>
    </CCard>
    <CCard
      v-bind:key="empresa.codEmpresa"
      v-for="empresa in empresas"
      accent-color="secondary"
      class="mt-1 mb-1"
    >
      <CCardHeader>
        <CRow no-gutters class="align-items-center">
          <!-- Despliegue trabajadores empresa -->
          <span class="card-header-actions d-flex justify-content-center align-items-center">
                <CLink class="card-header-action btn-minimize float-right" @click="desplegarEmpresa(empresa)">
                    <CIcon :name="`cil-chevron-${empresa.desplegada ? 'bottom' : 'top'}`" />
                </CLink>
                
                <span v-show="provTabPrincipal" class="ml-1" @click="enviarNuevoTab(empresa)" v-tippy="getBaseTippy(`Desplegar en Pestaña`)">
                    <CIcon name="cil-object-ungroup" />
                </span>
          </span>

          <!-- Mostrar informacion de la empresa -->
          <CCol sm="4" md="4" lg="4" xl="3" class="d-flex align-items-center">
            <div>
              <a
                style="text-decoration: none; color: #0b7689; vertical-align: middle;"
                class="ml-1 mr-1"
                v-tippy="getBaseTippy(`Ver Info Empresa`)"
                @click="mostrarInfoEmpresa(empresa)"
              >
                <span
                  class="pi pi-info-circle"
                  style="font-size: 1rem; color: #0b7689"
                ></span>
              </a>
              <span v-tippy="getBaseTippy(`Rut empresa: ${$utils.formatearRut(empresa.rutEmpresa)}`)">
                ({{ empresa.codEmpresa }}) {{ empresa.nombreEmpresa }}
              </span>
              <span v-tippy="getBaseTippy(`Numero de trabajadores`)">
                <CBadge shape="pill" color="secondary" style="font-size: 0.6rem;">{{empresa.infoEmpresa.totalTrabajadores}}</CBadge>
                </span>
            </div>
          </CCol>

          <!-- Estado empresa -->
          <CCol sm="4" md="3" lg="3" xl="2" class="d-flex align-items-center justify-content-start">
            <span>
              <CBadge
                class="m-1"
                style="font-size: 0.7rem; font-weight: normal"
                v-tippy="getBaseTippy($utils.getEstadoEmpresa(empresa.estado))"
                shape="pill"
                :color="$utils.getColorEstadoEmpresa(empresa.estado)"
              >
                <CIcon
                  v-if="empresa.estado == 1"
                  style="width: 20px; height: 20px"
                  :content="$options.freeSet.cilArrowCircleRight"
                />
                <CIcon
                  v-else-if="empresa.estado == 2"
                  style="width: 20px; height: 20px"
                  :content="$options.freeSet.cilXCircle"
                />
                <CIcon
                  v-else-if="empresa.estado == 3"
                  style="width: 20px; height: 20px"
                  :content="$options.freeSet.cilCheckCircle"
                />
              </CBadge>
              <CBadge
                v-show="empresa.periodoCerrado"
                class="m-1"
				v-tippy="getBaseTippy(`Periodo Cerrado ${
                  empresa.fechaPeriodoCerrado == undefined ||
                  empresa.fechaPeriodoCerrado == ''
                    ? 'por aplicación Edig'
                    : $utils.formatFechaEnDistancia(empresa.fechaPeriodoCerrado)
                }`)"
                shape="pill"
                style="
                  font-size: 0.7rem;
                  font-weight: normal;
                  background-color: #29235c;
                  color: white;
                "
              >
                <CIcon
                  style="width: 20px; height: 20px"
                  :content="$options.freeSet.cilLockLocked"
                />
              </CBadge>

              <CButton
                v-show="
                  tipoDocumento.valor != 'contratos' &&
                  !empresa.periodoCerrado &&
                  empresa.estado == 3
                "
                shape="pill"
				v-tippy="getBaseTippy(`Cerrar Período`)"
                style="font-size: 11px; padding: 1px"
                class="btnPrincipalVapp"
                @click="cerrarPeriodo(empresa)"
              >
                <CIcon
                  style="width: 20px; height: 20px"
                  :content="$options.freeSet.cilDoor"
                />
              </CButton>
              <CButton
                v-show="empresa.periodoCerrado && empresa.estado == 3"
                shape="pill"
				v-tippy="getBaseTippy(`Abrir Periodo`)"
                style="font-size: 11px; padding: 1px"
                class="btnPrincipalVapp"
                @click="abrirPeriodo(empresa)"
              >
                <CIcon
                  style="width: 20px; height: 20px"
                  :content="$options.freeSet.cilRoom"
                />
              </CButton>
            </span>
          </CCol>

          <!-- Revision -->
          <CCol sm="4" md="5" lg="5" xl="5" class="d-flex align-items-center justify-content-center">
            
            <!--<CDropdown
                color="drpdwn-menu"
                split
                toggler-text="Split Dropdown"
                class="mr-1"
            >
                <template #toggler-content>
                    <CIcon
                        :content="$options.freeSet.cilWarning"
                    /> 
                    <span class="ml-1">asd</span>

                </template>
                <div role="group">
                    <CDropdownItem >
                        asd1
                    </CDropdownItem>
                    <CDropdownItem >
                        asd2
                    </CDropdownItem>
                </div>
            </CDropdown>-->
            <span>
              <CButton
                class="btnPrincipalVapp"
                v-show="empresa.enviandoEmpresa"
              >
                <CIcon
                  :content="$options.freeSet.cilLoopCircular"
                  class="imgr"
                />
                <span v-show="usaPortalEmpresa && !tipoUserAdmin"
                  >Enviando Empresa</span
                >
                <span v-show="usaPortalEmpresa && tipoUserAdmin"
                  >Aceptando</span
                >
                <span v-show="!usaPortalEmpresa && tipoUserAdmin"
                  >Aceptando</span
                >
              </CButton>
              <span v-show="usaPortalEmpresa">
                <CButton
                  class="btnPrincipalVapp mr-1"
                  v-show="
                    !empresa.enviandoEmpresa &&
                    empresa.estado != 1 &&
                    empresa.infoEmpresa.totalTrabajadores > 0 &&
                    !empresa.enviarEmpresa
                  "
				  v-tippy="getBaseTippy(empresa.userNotificar.length == 0 ? '(!) OJO - No tiene usuario para revision' : 'Enviar a Revision')"
                  @click="enviarEmpresa(empresa)"
                >
                <i class="pi pi-upload"></i>
                  {{ empresa.estado == 3 ? "Volver a Enviar" : "Enviar" }}
                <span v-show="empresa.userNotificar.length == 0" class="alertaSinUsuario">!</span>
                  
                </CButton>
              </span>
              <span
                v-show="tipoUserAdmin || (!tipoUserAdmin && !usaPortalEmpresa)"
              >
                <CButton
                  
                  class="btnPrincipalVapp"
                  v-show="
                    !empresa.enviandoEmpresa &&
                    empresa.estado != 1 &&
                    empresa.estado != 3 &&
                    empresa.infoEmpresa.totalTrabajadores > 0 &&
                    !empresa.enviarEmpresa
                  "
                  @click="empresa.enviarEmpresa = true"
                >
                <i class="pi pi-check"></i>
                  Aceptar
                </CButton>

                <CButtonGroup
                  size="sm"
                  class="mx-1"
                  v-show="empresa.enviarEmpresa"
                >
                  <CButton
                    color="success"
                    size="sm"
                    @click="
                      aceptarEmpresa(empresa);
                      empresa.enviarEmpresa = false;
                    "
					v-tippy="getBaseTippy('Aceptar Empres')"
                  >
                    <CIcon name="cil-check-circle" />
                  </CButton>

                  <CButton
				  	v-tippy="getBaseTippy('Cancelar')"
                    color="danger"
                    @click="empresa.enviarEmpresa = false"
                    size="sm"
                    ><CIcon name="cil-x-circle" />
                  </CButton>
                </CButtonGroup>
                <span v-show="empresa.infoEmpresa.totalTrabajadores == 0">
                  <CButton
                    size="sm"
                    variant="ghost"
				  	v-tippy="getBaseTippy('No hay informacion para ser Aceptada')">
                    <CIcon :content="$options.freeSet.cilWarning" />
                  </CButton>
                </span>
                <!--<span v-show="!empresa.enviandoEmpresa && empresa.estado==3">Periodo Aceptado</span>-->
              </span>
              <span v-show="!empresa.enviandoEmpresa && empresa.estado == 1">
                <CButton
                  :disabled="empresa.cancelandoEnvio"
                  class="btnPrincipalVapp"
                  size="sm"
				  v-tippy="getBaseTippy('Cancelar revisión Empresa')"
                  @click="cancelarRevision(empresa)"
                >
                  <CIcon
                    :class="empresa.cancelandoEnvio ? 'imgr' : ''"
                    :content="$options.freeSet.cilXCircle"
                  />
                  Cancelar Revisión
                </CButton>
              </span>
            </span>
          </CCol>
        </CRow>
        
      </CCardHeader>
      
      <CCollapse :show="empresa.desplegada" :duration="400">
        <CCardBody>
          
            <!-- Filtros -->
            <CRow>
              <CCol md="4">
                <FiltroTrabajadoresComponente
                  :ref="empresa.idEmpresa + 'filtroTrab2'"
                  :empresaSelected="empresa"
                  :tipoDocSelected="tipoDocumento"
                  :mesSelected="mesSeleccionado"
                  :anioSelected="periodoSeleccionado"
                  @seleccionarTrab="filtrarTrabajadores($event, empresa)"
                />
              </CCol>
              <CCol md="3">
                <OpcionesFiltrosTrabajadores
                  :opcionesFiltrosTrabajadores="empresa.opcionesFiltrosTrabajadores"
                  @seleccionarFiltro="seleccionFiltro($event, empresa)"
                />
              </CCol>
			  <CCol>
				<span>
					<CDropdown
						color="drpdwn-menu"
						class="mt-1"
						size="sm"
						v-show="empresa.desplegada"
						>
						<template #toggler-content>
							<!--:disabled="empresa.isActualizandoDocumentos || empresa.isLoadingEnvioTodos || empresa.isLoadingGenerarDocumento || empresa.isDescargando"-->
							<CIcon
							:class="
								empresa.isActualizandoDocumentos ||
								empresa.isLoadingEnvioTodos ||
								empresa.isLoadingGenerarDocumento ||
								empresa.isDescargando ? 'imgr' : ''
							"
							:content="$options.freeSet.cilApplications"
							/> 
							<span class="ml-1">Opciones trabajadores</span>

						</template>
						<div role="group">
							<CDropdownHeader
							v-show="empresa.periodoCerrado"
							class="font-weight-bold"
							v-tippy="getBaseTippy('Opciones deshabilitadas por que el periodo se encuentra cerrado')">
							<CIcon
								style="color: #f9b115"
								:content="$options.freeSet.cilWarning"
							/>
							Hay Opciones deshabilitadas </CDropdownHeader
							><!--icono Periodo Cerrado-->

							<!--<CDropdownItem
							:disabled="
								empresa.isActualizandoDocumentos ||
								empresa.isLoadingEnvioTodos ||
								empresa.isLoadingGenerarDocumento ||
								empresa.isDescargando ||
								empresa.estado == 1 ||
								empresa.estado == 3
							"
							v-show="tipoDocumento.permiteSubirDocs"
							@click="mostrarSubirArchivos(empresa)"
							>
							<CIcon
								class="mr-1"
								:content="
								empresa.periodoCerrado
									? $options.freeSet.cilWarning
									: $options.freeSet.cilCloudUpload
								"
							/>
							Subir Documentos
							</CDropdownItem>-->

							<!--<CDropdownItem
							v-tippy="getBaseTippy(empresa.mostrarMensajeActualizacionDocumentos
								? empresa.mensajeActualizacionDocs
								: 'Actualizar Documentos')"
							:disabled="
								empresa.isActualizandoDocumentos ||
								empresa.isLoadingEnvioTodos ||
								empresa.isLoadingGenerarDocumento ||
								empresa.isDescargando ||
								empresa.estado == 3
							"
							v-show="tipoDocumento.valor == 'liquidaciones'"
							@click="actualizarDocumentosEmpresa(empresa)"
							>
							<CIcon
								class="mr-1"
								:class="empresa.isActualizandoDocumentos ? 'imgr' : ''"
								:content="
								empresa.periodoCerrado
									? $options.freeSet.cilWarning
									: $options.freeSet.cilLoopCircular
								"
							/>
							{{
								empresa.isActualizandoDocumentos
								? "Actualizando "
								: "Actualizar "
							}}
							Documentos

							<CIcon
								class="ml-1"
								v-show="empresa.mostrarMensajeActualizacionDocumentos"
								:content="$options.freeSet.cilInfo"
							/>
							</CDropdownItem>-->

							<!--<CDropdownItem 
																	v-show="tipoDocumentoSelected.permiteGenerarDoc" 
																	:disabled="empresa.isActualizandoDocumentos || empresa.isLoadingEnvioTodos || empresa.isLoadingGenerarDocumento || empresa.isDescargando"
																	@click="generarDocumentos(empresa)" >
																	<CIcon class="mr-1" 
																		:class="(empresa.isLoadingGenerarDocumento)?'imgr':''" 
																		:content="$options.freeSet.cilLibraryAdd" /> Generar Documentos
																</CDropdownItem>-->

							<CDropdownItem
							v-tippy="getBaseTippy(empresa.txtEnviarTodos)"
							v-show="empresa.hayDocumentosTrabajador"
							:disabled="
								empresa.isActualizandoDocumentos ||
								empresa.isLoadingEnvioTodos ||
								empresa.isLoadingGenerarDocumento ||
								empresa.isDescargando
							"
							@click="enviaraTodos(empresa)"
							>
							<CIcon
								class="mr-1"
								:class="empresa.isLoadingEnvioTodos ? 'imgr' : ''"
								:content="$options.freeSet.cilEnvelopeLetter"
							/>
							Enviar Documentos
							</CDropdownItem>
						</div>
						<div role="group" v-show="empresa.hayDocumentosTrabajador">
							<CDropdownDivider />
							<CDropdownHeader class="font-weight-bold">
							<CIcon
								class="mr-1"
								:class="empresa.isDescargando ? 'imgr' : ''"
								:content="$options.freeSet.cilCloudDownload"
							/>
							Descarga de Documentos
							</CDropdownHeader>
							<CDropdownItem
							:disabled="
								empresa.isActualizandoDocumentos ||
								empresa.isLoadingEnvioTodos ||
								empresa.isLoadingGenerarDocumento ||
								empresa.isDescargando
							"
							v-tippy="getBaseTippy('Descargar un Archivo con todos los documentos')"
							@click="descargarArchivo('merge', empresa)"
							>
							<CIcon
								class="mr-1"
								:class="empresa.isDescargando ? 'imgr' : ''"
								:content="$options.freeSet.cilSwapVertical"
							/>
							Documentos Unificados
							</CDropdownItem>
							<CDropdownItem
							v-tippy="getBaseTippy('Descargar todos los documentos comprimidos')"
							:disabled="
								empresa.isActualizandoDocumentos ||
								empresa.isLoadingEnvioTodos ||
								empresa.isLoadingGenerarDocumento ||
								empresa.isDescargando
							"
							@click="descargarArchivo('zip', empresa)"
							>
							<CIcon
								class="mr-1"
								:class="empresa.isDescargando ? 'imgr' : ''"
								:content="$options.freeSet.cilCompress"
							/>
							Documentos comprimidos
							</CDropdownItem>
						</div>
						</CDropdown>
					</span>
			  </CCol>
            </CRow>

            <!-- Subida documentos (?) -->
            <subida-documentos
                v-show="empresa.mostrarSubirDocumentos"
                :empresa="empresa">
            </subida-documentos>

            <!-- Cargar informacion -->
            <CargandoInfo
              :mostrarCarga="empresa.isLoadingTrabajadores"
              :mensajeInfo="'Obteniendo sus Trabajadores'"
            />

            <!-- Tabla trabajadores -->
            <TablaTrabajadoresDocumentos 
              v-show="!empresa.isLoadingTrabajadores"
              :portContador="true"
              :empresa="empresa"
              :periodoCerrado="empresa.periodoCerrado"
              :periodoSelected="periodoSeleccionado"
              :mesSelected="mesSeleccionado"
              :trabajadores="empresa.trabajadores"
              :loading="false"
              :paginacion="empresa.paginacion"
              :tipoDocumentoSelected="tipoDocumento"
              :totalTrabajadoresDocumentos="empresa.totalTrabajadoresDocumentos"
              :totalTrabajadores="empresa.totalTrabajadores"
              :mostrarPeriodo="mostrarPeriodo"
              @obtenerTrabajadores="getTrabajadoresInfoEmpresa(empresa)"
            />

          
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
import apiUrls from "@/views/utils/apiUrls";
import axios from "axios";
import cons from "@/const";
import * as util from '@/views/utils/utilsFunctions'
import { freeSet } from "@coreui/icons";

import { PrimeIcons } from '@primevue/core/api';

import FileUpload from "vue-upload-component";

import TablaTrabajadoresDocumentos from "./TablaTrabajadoresDocumentos";
import ModalInfoEmpresa from "./ModalInfoEmpresa";
import FiltroTrabajadoresComponente from "./FiltroTrabajadoresComponente";
import OpcionesFiltrosTrabajadores from "./filtros/OpcionesFiltrosTrabajadores";
import CargandoInfo from "@/views/utils/CargandoInfo";
import SubidaDocumentos from './SubidaDocumentos';

export default {
  name: "InfoEmpresa",
  freeSet,
  components: {
    TablaTrabajadoresDocumentos,
    ModalInfoEmpresa,
    FiltroTrabajadoresComponente,
    OpcionesFiltrosTrabajadores,
    CargandoInfo,
    FileUpload,
    SubidaDocumentos,
  },
  props: {
    empresas: Array,
    tipoDocumento: Object,
    mesSeleccionado: Object,
    periodoSeleccionado: Object,
    mostrarPeriodo: Boolean,
    provTabPrincipal: Boolean,
  },
  data() {
    return {
      isMobile: false,
      urlBase: cons.port + "://" + cons.ipServer,

      tokenLogin: JSON.parse(this.$cookie.get("userLogginToken")).tokenUsuario,
      tipoUserAdmin: JSON.parse(this.$cookie.get("userLogginToken"))
        .tipoUsuario,
      idCliente: JSON.parse(this.$cookie.get("userLogginToken")).idCliente,
      usaPortalEmpresa: JSON.parse(this.$cookie.get("userLogginToken"))
        .usaPortalEmpresa,

      empresaSeleccionadaInfo: {},
      infoEmpresaModal: false,

      /** Modal Envio Empresa */
      isLoadingEnviandoEmpresa: false,

      mensajeCorreoInvalido: false,
      mostrarModalEnvioEmpresa: false,
      editCorreoEncargado: false,
      empresaEnviada: false,
      msjEnviandoRevision: "Enviando...",
      respEmpresaEnviar: {},
      /** Fin Modal Envio Empresa */

      mostrarSubirDocumentos: false,
    };
  },
  	computed: {
		test: function() {
			return window.innerWidt
		},
		esPantallaPequena() {
			return window.innerWidth <= 768; // sm o xs
		}
	},
  methods: {
    enviarNuevoTab: function(empresa){
        this.$emit('enviarNuevoTab', {
            codEmpresa: empresa.codEmpresa,
            nombreEmpresa: empresa.nombreEmpresa,
        })
    },
    checkDevice() {
        this.isMobile = util.getTipoDispositivoEsMobile()
    },
    mostrarInfoEmpresa: function (empresa) {
      this.$emit("mostrarInfoEmpresa", empresa);
    },
    cerrarPeriodo: function (empresa) {
      this.$emit("cerrarPeriodo", empresa);
    },
    abrirPeriodo: function (empresa) {
      this.$emit("abrirPeriodo", empresa);
    },
    filtrarTrabajadores: function (evento, empresa) {
      empresa.trabajadoresFiltrados = evento;
      empresa.paginacion.current = 1;

      this.getTrabajadoresInfoEmpresa(empresa);
    },
    desplegarEmpresa: function (empresa) {
      let refUnico = `${empresa.idEmpresa}filtroTrab2`;
      empresa.desplegada = !empresa.desplegada;
      if (empresa.desplegada){
        this.getTrabajadoresInfoEmpresa(empresa);
      }
      //this.$emit("obtenerTrabajadores", true, empresa);
      //this.$refs[refUnico][0].getTrabajadores();
      //let key = "tblTrabajadores" + empresa.codEmpresa;
      //this.getTrabajadores(empresa.desplegada, empresa);
    },
    actualizarFiltro: function (empresa) {
      let refUnico = `${empresa.idEmpresa}filtroTrab2`;

      //this.$refs[refUnico][0].getTrabajadores();
    },
    seleccionFiltro: function (evento, empresa) {
      empresa.opcionSeleccionadaFiltro = evento;
      this.getTrabajadoresInfoEmpresa(empresa);
    },
    /*mostrarSubirArchivos: function(empresa){
        empresa.mostrarSubirDocumentos = !empresa.mostrarSubirDocumentos

        this.empresaSeleccionadaSubirArchivos = empresa
        this.subirDocumentosModal = true
        
        if(empresa.mostrarSubirDocumentos){
            this.generarLinkSubidaArchivos(empresa)
        }
    },
    actualizarDocumentosEmpresa: function (empresa) {
      this.$emit("actualizarDocumentosEmpresa", empresa)
    },*/
    getTrabajadoresInfoEmpresa: function (empresa) {
      if (empresa.trabajadoresFiltrados.length > 0) {
        empresa.txtEnviarTodos =
          "Enviar Documentos a Trabajadores Seleccionados";
        empresa.txtActualizarDocs =
          "Actualizar Documentos Trabajadores Seleccionados";
        empresa.txtDescargarDocumentos =
          "Descargar Documentos Trabajadores Seleccionados";
      } else {
        empresa.txtEnviarTodos = empresa.txtEnviarTodosResp;
        empresa.txtActualizarDocs = "Actualizar Documentos";
        empresa.txtDescargarDocumentos = "Descargar Documentos";
      }

      empresa.isLoadingTrabajadores = true;
      let url = `${
        this.urlBase +
        apiUrls.general.getTrabajadoresEmpresa +
        empresa.idEmpresa
      }/${this.tipoDocumento != null ? this.tipoDocumento.valor : "null"}/${
        this.mesSeleccionado != null ? this.mesSeleccionado.valor : "null"
      }/${
        this.periodoSeleccionado != null
          ? this.periodoSeleccionado.valor
          : "null"
      }`;

      axios({
        method: "POST",
        url: url,
        data: {
          filtrarPorPeriodo: this.mostrarPeriodo,
          paginacionTrabajadores: {
            actual: empresa.paginacion.current,
            tamanioPagina: empresa.paginacion.pageSize,
            filtrosTrabajadores: empresa.trabajadoresFiltrados,
            filtros: empresa.opcionSeleccionadaFiltro,
          },
        },
        headers: {
          Authorization: `${this.tokenLogin}`,
        },
      })
        .then(
          (result) => {
            empresa.trabajadores = result.data.trabajadores;
            empresa.totalTrabajadoresDocumentos =
              result.data.totalDocumentosTrab;
            empresa.totalTrabajadores = result.data.totalTrabajadores;

            if (empresa.totalTrabajadoresDocumentos > 0) {
              empresa.hayDocumentosTrabajador = true;
            }
            const pagination = { ...empresa.paginacion };
            pagination.total = result.data.totalTrabajadores;
            pagination.empresa = empresa;
            empresa.paginacion = pagination;

            this.actualizarFiltro(empresa);
          },
          (error) => {
            this.mostrarNotificaciones(3, error.response.data.mensajeGeneral);
          }
        )
        .finally(() => {
          empresa.isLoadingTrabajadores = false;
        });
    },
    /*generarLinkSubidaArchivos: function (empresa) {
      this.$emit("generarLinkSubidaArchivos", empresa)
    },*/
    enviarEmpresa: function (empresa) {
      this.$emit("enviarEmpresa", empresa);
    },
    aceptarEmpresa: function (empresa) {
      this.$emit("aceptarEmpresa", empresa)
    },
    cancelarRevision: function(empresa){
      this.$emit("cancelarRevision", empresa)
    },
    descargarArchivo: function(tipoDescarga, empresa){
      this.$emit("descargarArchivo", tipoDescarga, empresa)

      /* empresa.isDescargando = true
      
      let url = this.urlBase + `/descargar_documentos/`
      let trabajadores = []
      if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
          empresa.trabajadoresFiltrados.forEach(trabajador => {
              trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
          });
      }
      axios({
          url: url,
          method: 'POST',
          "data": {
              "tipoBd": "REMU",
              "tipoDescarga": tipoDescarga,
              "codEmpresa": empresa.codEmpresa,
              "idEmpresa": empresa.idEmpresa,
              "filtrarPorPeriodo": this.mostrarPeriodo,
              "anioPeriodo": (this.periodoSeleccionado != null) ? this.periodoSeleccionado.valor : null,
              "mesPeriodo":(this.mesSeleccionado != null) ? this.mesSeleccionado.valor : null,
              "tipoDocumento": (this.tipoDocumento != null) ? this.tipoDocumento.valor : null,
              "infoTrabajadores": {
                  "trabajadoresSelected": [],
                  "trabajadores": trabajadores
              }
          },
          "headers": {
              'Authorization': `${this.tokenLogin}`
          },

      }).then((response) => {
          //this.msjDescargando = "Iniciando Descarga"

          //this.$notification.success(response.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
          //this.mostrarNotificaciones(1, response.data.mensajeGeneral)
          const link = document.createElement('a')
          link.href = response.data.archivo.link
          link.download = response.data.archivo.nombre
          link.click()
          URL.revokeObjectURL(link.href)

          //this.$notification.success("Iniciando Descarga", {  timer: 10, position:"bottomRight", showCloseIcn:true});
          this.mostrarNotificaciones(1, `${response.data.mensajeGeneral}, Iniciando Descarga`)

      }, error => {
          this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
          //this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
      })
      .finally(() => {
          empresa.isDescargando = false
      }); */
    },
    enviarRevision: function(){
      

        this.isLoadingEnviandoEmpresa = true
        this.empresaEnviar.enviandoEmpresa = true
        
        
        
        
        this.mostrarModalEnvioEmpresa = false
        this.mostrarNotificaciones(1, `Enviando empresa ${this.empresaEnviar.codEmpresa}`)
        
        
        let url = this.urlBase + apiUrls.remuneraciones.enviarEmpresaRevision

        axios({
            method: "POST", 
            "url": url,
            "data": {
                "datosEnvio": {
                    "modificarCorreoEmpresa": this.modificarCorreoEmpresa,
                    "tipoDocumento": (this.tipoDocumento != null) ? this.tipoDocumento.valor : null,
                    "mesPeriodo": (this.mesSeleccionado != null) ? this.mesSeleccionado.valor : null,
                    "anioPeriodo": (this.periodoSeleccionado != null) ? this.periodoSeleccionado.valor : null,
                    "empresaEnviar": {
                        "idEmpresa": this.empresaEnviar.idEmpresa,
                        "userNotificar": this.empresaEnviar.userNotificar,
                        "notificar": this.empresaEnviar.notificar
                    },
                    "mostrarPorPeriodo": this.mostrarPeriodo,
                }
            },
            "headers": {
                'Authorization': `${this.tokenLogin}`
            }
        }).then(result => {

            this.empresas[this.empresas.indexOf(this.empresaEnviar)].estado = result.data.estadoEmpresa
            if(this.getTrabajadoresInfoEmpresa(this.empresas[this.empresas.indexOf(this.empresaEnviar)].hasOwnProperty('expandirEmpresa'))){
                this.empresas[this.empresas.indexOf(this.empresaEnviar)].expandirEmpresa = false
            }
            
            this.getTrabajadoresInfoEmpresa(this.empresas[this.empresas.indexOf(this.empresaEnviar)].expandirEmpresa, this.empresas[this.empresas.indexOf(this.empresaEnviar)])
            
            this.mostrarNotificaciones(1, result.data.mensaje)
            
            
            
        }, error => {
            this.mostrarNotificaciones(3, error.response.data.mensaje)
            
            
        })
        .finally(() => {
            this.isLoadingEnviandoEmpresa = false
            this.empresaEnviar.enviandoEmpresa = false
        });
    },
    refrescarEmpresas: function(){
        this.isRefrescando = true
        this.getTrabajadoresInfoEmpresa(this.tipoDocumento)
    },

    /* METODOS SUBIR ARCHIVOS */
    cerrarModalSubirArchivos: function () {
        this.subirDocumentosModal = false;
        
    },
    subirTodoActivar: function(empresa){
      if(empresa.subidaDocsID == null){
          
        this.$refs.upload.active = true
        this.validarDocsError(empresa)

            var idInt = setInterval(function(){
                this.validarDocumentosSubidos(empresa);
            }.bind(this), 1000);
            empresa.subidaDocsID = idInt
        }
    },
    validarDocsError: function(empresa){
      empresa.archivosSubir.forEach(archivo => {
        if(!archivo.success && archivo.error != ""){
          this.$refs.upload.update(archivo, {active: true,error: '',progress: '0.00'})
        }
      });

    },
    validarDocumentosSubidos: function(empresa){
      if(empresa.archivosSubir.length == 0){
            clearInterval(empresa.subidaDocsID)
            empresa.subidaDocsID = null
        }
        else{
            var finalizados = 0
            empresa.archivosSubir.forEach(archivo => {
                if((!archivo.active && parseInt(archivo.progress) == 100) || (!archivo.active && archivo.error == "Cancelado") || (!archivo.active && archivo.success) || (!archivo.active && !archivo.success)){
                    finalizados++
                }
            })
            if(finalizados == empresa.archivosSubir.length){
                clearInterval(empresa.subidaDocsID)
                empresa.subidaDocsID = null
                this.getTrabajadoresInfoEmpresa(true, empresa)
            }
        } 
    },
    // add, update, remove File event
    inputFile(newFile, oldFile) {
      console.log("Primero")
      if (newFile && oldFile) {
        // update
        
        if (newFile.active && !oldFile.active) {
        // beforeSend
        // min size
        if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
        ) {
          
            this.$refs.upload.update(newFile, { error: "size" });
        }
        }
        if (newFile.progress !== oldFile.progress) {
        // progress
        
        }
        if (newFile.error && !oldFile.error) {
        // error
        }
        if (newFile.success && !oldFile.success) {
        // success
            this.empresasFiltradas.forEach(empresa => {
                if(newFile.response.idEmpresa == empresa.idEmpresa){
                    let haySinTerminar = false
                    empresa.archivosSubir.forEach(archivo =>{
                        if(archivo.active)
                            haySinTerminar = true
                        
                    })
                    if(!haySinTerminar){
                        this.getTrabajadoresInfoEmpresa(true, empresa)
                    }
                }
            })
        
        }
    }
    if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response.id) {
        // $.ajax({
        //   type: 'DELETE',
        //   url: '/upload/delete?id=' + oldFile.response.id,
        // })
        }
    }
    // Automatically activate upload
    if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
    ) {
        if (this.uploadAuto && !this.$refs.upload.active) {
        this.$refs.upload.active = true;
        }
    }

    },
    alert(message) {
      alert(message);
    },
    onEditFileShow(file) {
      this.editFile = { ...file, show: true };
      this.$refs.upload.update(file, { error: "edit" }); 
    },
    onAddData() {
      this.addData.show = false;
      if (!this.$refs.upload.features.html5) {
          this.alert("Your browser does not support");
          return;
      }
      let file = new window.File([this.addData.content], this.addData.name, {
          type: this.addData.type,
      });
      this.$refs.upload.add(file);
    },
  },
};
</script>